import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState, } from "react";
const defaultValue = {
    menuLayerElement: null,
    menuLayerOpen: false,
    setMenuLayerRef: () => { },
};
const MenuLayerContext = createContext(defaultValue);
export const MenuLayerProvider = ({ children, }) => {
    const [menuLayerOpen, setMenuLayerOpen] = useState(false);
    const [menuLayerElement, setMenuLayerElement] = useState(null);
    const menuObserverRef = useRef(undefined);
    const setMenuLayerRef = useCallback((ref) => {
        if (menuObserverRef.current !== undefined) {
            menuObserverRef.current.disconnect();
            menuObserverRef.current = undefined;
        }
        setMenuLayerElement(ref);
        if (ref !== null) {
            let hasChildren = ref.children.length > 0;
            setMenuLayerOpen(hasChildren);
            menuObserverRef.current = new MutationObserver(() => {
                const newHasChildren = ref.children.length > 0;
                if (newHasChildren !== hasChildren) {
                    hasChildren = newHasChildren;
                    setMenuLayerOpen(hasChildren);
                }
            });
            menuObserverRef.current.observe(ref, { childList: true });
        }
    }, []);
    useEffect(() => {
        return () => {
            if (menuObserverRef.current !== undefined) {
                menuObserverRef.current.disconnect();
            }
        };
    }, []);
    const contextValue = useMemo(() => ({
        menuLayerElement,
        menuLayerOpen,
        setMenuLayerRef,
    }), [menuLayerElement, menuLayerOpen, setMenuLayerRef]);
    return (React.createElement(MenuLayerContext.Provider, { value: contextValue }, children));
};
export const MenuLayerConsumer = MenuLayerContext.Consumer;
export function useMenuLayerContext() {
    return useContext(MenuLayerContext);
}
